import { ShoppingBag, Plug, Rocket, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HowItWorksSection() {
  const { t } = useTranslation();

  const STEPS = [
    {
      number: "01",
      icon: ShoppingBag,
      titleKey: "how_it_works_section.step_1_title",
      descKey: "how_it_works_section.step_1_desc",
      linkTo: "/marketplace",
      linkText: t("marketplace_page.browse_agents"),
    },
    {
      number: "02",
      icon: Plug,
      titleKey: "how_it_works_section.step_2_title",
      descKey: "how_it_works_section.step_2_desc",
      linkTo: "/marketplace",
      linkText: t("integrations_page.view_all"),
    },
    {
      number: "03",
      icon: Rocket,
      titleKey: "how_it_works_section.step_3_title",
      descKey: "how_it_works_section.step_3_desc",
      linkTo: "/pricing",
      linkText: t("pricing_section.cta"),
    },
  ];

  return (
    <section
      data-testid="how-it-works-section"
      className="border-t border-zinc-900 bg-[#09090B] py-24"
      aria-labelledby="how-it-works-heading"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-8 mb-16">
          <div className="col-span-12 md:col-span-5">
            <div
              className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber-500 mb-4"
              aria-hidden="true"
            >
              // {t('how_it_works_section.title').toUpperCase()}
            </div>
            <h2
              id="how-it-works-heading"
              className="font-display text-4xl md:text-5xl uppercase leading-tight"
            >
              {t('how_it_works_section.title')}{" "}
              <span className="text-amber-500">3 Steps</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 self-end">
            <p className="text-zinc-400 text-lg leading-relaxed">
              {t('how_it_works_section.subtitle')}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {STEPS.map((step) => {
            const Icon = step.icon;
            return (
              <div
                key={step.number}
                data-testid={`how-it-works-step-${step.number}`}
                className="group border border-zinc-900 bg-zinc-950/50 p-8 hover:border-amber-500/30 transition-colors flex flex-col"
              >
                <span
                  className="font-display text-4xl text-amber-500 mb-4"
                  aria-hidden="true"
                >
                  {step.number}
                </span>

                <div className="w-12 h-12 border border-zinc-800 bg-amber-500/10 flex items-center justify-center mb-6 group-hover:border-amber-500/40 transition-colors">
                  <Icon className="w-5 h-5 text-amber-500" aria-hidden="true" />
                </div>

                <h3 className="font-display text-xl uppercase tracking-tight mb-3">
                  {t(step.titleKey)}
                </h3>

                <p className="text-zinc-400 text-sm leading-relaxed flex-1">
                  {t(step.descKey)}
                </p>

                <div className="mt-6 pt-6 border-t border-zinc-900">
                  <Link
                    to={step.linkTo}
                    className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-amber-500 hover:text-amber-400 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
                  >
                    {step.linkText}
                    <ArrowRight
                      className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform"
                      aria-hidden="true"
                    />
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
